module.exports = __webpack_public_path__ + "staticcomp/img/content_3.6a6108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_3.png
// module id = UqcF
// module chunks = 39